// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__lCWlq","title":"AfterBackImages_title__3vt7w","images":"AfterBackImages_images__2L3Ga"};